<script lang="ts">
    export let hover: string = '';
    export let src: string = '';
    export let alt: string = '';
    export let scale: number = 1;
    export let style: string = '';
    export let styleElement: string = '';
    export let spin: boolean = false;
    /**
     * Ikona wyłączona - nie reaguje na kliknięcia i jest wyszarzona. Sam CSS nie jest jednak
     * blokadą: `on:click` jest przekazywane dalej, więc handler wywołującego musi mieć własne
     * wczesne wyjście (w jsdom `pointer-events: none` nie powstrzymuje zdarzenia).
     */
    export let disabled: boolean = false;

</script>


<div on:click class:spin class:disabled title={hover} style="width:{30*scale}px; height:{30*scale}px; {styleElement}" class="icon" >
    <img {src} {alt} style="width:{30*scale}px; height:{30*scale}px; {style}" />
</div>


<style lang="scss">
  .icon:hover {
    cursor: pointer;
  }
  @keyframes spin-animate {
      from {
          transform: rotate(0deg);
      }
      to {
          transform: rotate(360deg);
      }
  }

  .spin {
      // filter: blur(1px) brightness(0.8) saturate(0.8) contrast(1.2);
      filter: scale(0.8);
      animation: spin-animate 0.3s linear infinite;
  }

  .icon.disabled {
      pointer-events: none;
      opacity: 0.4;
      cursor: not-allowed;
  }

</style>